import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { emailRegex } from "utils/constants";
import * as Yup from "yup";
import axiosInstance from "../../utils/services/api";

const LogIn = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  console.log("HIIIIIII");

  const initialValues = {
    email: "",
    password: "",
    keepLoggedIn: false,
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(emailRegex, "Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .trim()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,14}$/,
        "Password should be 8-14 characters with at least one lowercase, one uppercase, one number, and one special character from @$!%*?&#."
      ),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const fcmToken = localStorage.getItem("deviceFCM");
      const response = await axiosInstance.post("/auth/login", {
        ...values,
        ...(fcmToken && { fcmToken }),
        device: "web",
      });

      toast.success(response?.data?.message);
      localStorage.setItem(
        "accessToken",
        response?.data?.data?.tokens?.access?.token
      );
      localStorage.setItem(
        "refreshToken",
        response?.data?.data?.tokens?.refresh?.token
      );
      window.location.replace("/admin/dashboard");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        "An error occurred. Please try again later.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2">
      <div className="mt-[10vh] w-full max-w-[500px] flex-col items-center md:pl-4">
        <div className="form-container mx-auto w-full rounded-xl bg-white p-6 shadow-lg dark:bg-navy-900 md:w-[400px]">
          <h4 className="mb-2.5 text-center text-4xl font-bold text-navy-700">
            Sign In
          </h4>
          <p className="mb-9 text-center text-base text-gray-600">
            Enter your email and password to proceed!
          </p>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                {/* Email */}
                <div className="mb-3">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Email Address <span className="text-red-700">*</span>
                  </label>
                  <Field
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your Email"
                    className="mt-1 w-full rounded-xl border p-3 text-sm outline-none focus:border-gray-700 dark:border-white/10 dark:text-white"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="mt-1 text-sm text-red-500"
                  />
                </div>

                {/* Password */}
                <div className="mb-3">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Password <span className="text-red-700">*</span>
                  </label>
                  <div className="relative">
                    <Field
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      placeholder="Enter Your Password"
                      className="mt-1 w-full rounded-xl border p-3 text-sm outline-none focus:border-gray-700 dark:border-white/10 dark:text-white"
                    />
                    <span
                      className="absolute right-3 top-4 cursor-pointer"
                      onClick={() => setShowPassword((prev) => !prev)}
                    >
                      {showPassword ? <RiEyeLine /> : <RiEyeOffLine />}
                    </span>
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="mt-1 text-sm text-red-500"
                  />
                </div>

                {/* Keep me logged in */}
                <div className="mb-4 flex items-center justify-between px-2">
                  <div className="flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      id="keepLoggedIn"
                      checked={values.keepLoggedIn}
                      onChange={() =>
                        setFieldValue("keepLoggedIn", !values.keepLoggedIn)
                      }
                      className="mr-2"
                    />
                    <label
                      htmlFor="keepLoggedIn"
                      className="text-sm font-medium text-navy-700 dark:text-white"
                    >
                      Keep me logged in
                    </label>
                  </div>
                  <Link
                    to="/auth/forgot-password"
                    className="text-sm font-medium text-[#06A7E0]"
                  >
                    Forgot Password?
                  </Link>
                </div>

                {/* Submit button */}
                <button
                  type="submit"
                  className="mt-2 w-full rounded-xl bg-blueSecondary py-3 text-base font-medium text-white transition duration-200 active:bg-[#14AADD] dark:bg-brand-400 dark:hover:bg-brand-300"
                  disabled={loading}
                >
                  {loading ? "Logging In..." : "Login"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default LogIn;